import { render, staticRenderFns } from "./triagem.vue?vue&type=template&id=d7dee190"
import script from "./triagem.vue?vue&type=script&lang=js"
export * from "./triagem.vue?vue&type=script&lang=js"
import style0 from "./triagem.vue?vue&type=style&index=0&id=d7dee190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports